import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Register } from '../../_models/register';
import { Router, ActivatedRoute } from '@angular/router';
import { Caller } from '../../_models/caller';
import { AlertService } from '../../_services/alert.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  errorMessage: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
  userName: string = "";
  key: string = "";
  statusText: string;
  statusText1: string = "";
  statusText2: string = "";
  tokenObj: any;

  constructor(private _location: Location, private alertService: AlertService, private http: HttpClient, private router: Router, public register: Register, public caller: Caller, private route: ActivatedRoute) {
    this.key = this.route.snapshot.params['key'];
  }

  ngOnInit() {
    this.tokenObj = this._location.getState();
  }

  SelectNewPassword() {
    this.statusText1 = "";
    if (this.newPassword == null || this.newPassword === undefined || this.newPassword === '' || this.newPassword === 'undefined') {
      this.statusText1 = " please enter new password"
    }
  }
  SelectConfirmPassword() {
    this.statusText2 = "";
    if (this.confirmPassword == null || this.confirmPassword === undefined || this.confirmPassword === '' || this.confirmPassword === 'undefined') {
      this.statusText2 = " please enter confirm password"
    }
  }


  submitResetPassword() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText = "";
    if (this.newPassword == '' || this.newPassword === null || this.newPassword === undefined || this.newPassword === 'undefined') {
      this.statusText1 = 'Please enter password';
    } else if (this.newPassword.length <= 5) {
      this.statusText1 = 'Password must be minimum 6 characters';
    }
    if (this.confirmPassword == '' || this.confirmPassword === null || this.confirmPassword === undefined || this.confirmPassword === 'undefined') {
      this.statusText2 = 'Please enter re-enter password';
    }

    if (this.statusText1 === "" && this.statusText2 === "") {
      if (this.newPassword != this.confirmPassword) {
        this.statusText = "Password does not match";
      }
    }
    if (this.statusText != "" || this.statusText1 != "" || this.statusText2 != "") {
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');

    this.http.post(environment.apiUrl + 'api/account/reset-password/finish', {
      "key": this.key,
      "newPassword": this.newPassword
    },
      { headers: header1 }
    ).subscribe(data => {

      if (data['code'] == 200) {
        this.alertService.success('Password', 'Created successfully');

        this.caller.parent = "RESET";
        //this.errorMessage = "OTP Created Successfully";
        this.router.navigate(['/access/login']);
      }
      else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "reset Failed, please re-try.";
      }
    )
  }
}
